import { WebSocketHelper } from 'classes/helpers/web-socket.helper';
import { MachineContext } from 'contexts/machine.context';
import { WsMsgType } from 'lib_ts/enums/machine-msg.enum';
import { ICalibrateResponseMsg } from 'lib_ts/interfaces/machine-msg/i-calibrate';
import { useContext, useEffect } from 'react';
import { useAuthStore } from 'stores/use-auth-store';
import useMachineStatusStore from 'stores/use-machine-status-store';

// listens for calibration msgs and updates the store
const useCalibrationListener = (): void => {
  const wsConnected = useAuthStore((s) => s.wsConnected);
  const { requestOverlayIDs } = useContext(MachineContext);

  useEffect(() => {
    if (!wsConnected) {
      return;
    }

    const callback = (event: CustomEvent) => {
      const data: ICalibrateResponseMsg = event.detail;

      useMachineStatusStore.setState({
        calibrated: data.status,
        canCalibrate: !!data.can_calibrate,
      });

      if (data.status) {
        requestOverlayIDs('useCalibrationListener');
      }
    };

    WebSocketHelper.on(WsMsgType.M2U_CalibrationResponse, callback);

    return () =>
      WebSocketHelper.remove(WsMsgType.M2U_CalibrationResponse, callback);
  }, [wsConnected]);
};

export default useCalibrationListener;
